import { INITIAL_DATA_LOADED } from "../types"

const initialState = {
  airport: undefined,
  terminal: undefined,
  operationType: [],
  airportTxt: "",
  areaTxt: "",
  operationTypeTxt: "",
}

export default function (state = initialState, action) {
  switch (action.type) {
    case INITIAL_DATA_LOADED:
      return {
        ...state,
        airport: action.payload.airport,
        terminal: action.payload.terminal,
        operationType: action.payload.operationType,
        airportTxt: action.payload.airportTxt,
        areaTxt: action.payload.areaTxt,
        operationTypeTxt: action.payload.operationTypeTxt,
      }
    default:
      return state
  }
}
